import './Background.css';

export function Background() {
  return (
    <div className="bg" aria-hidden="true">
      <div className="bg__aurora" />
      <div className="bg__grain" />
      <div className="bg__vignette" />
    </div>
  );
}
